import { render, staticRenderFns } from "./DnsPopupTable.vue?vue&type=template&id=2ef75998&scoped=true"
import script from "./DnsPopupTable.vue?vue&type=script&lang=js"
export * from "./DnsPopupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef75998",
  null
  
)

export default component.exports